import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { BellAlertIcon } from '@heroicons/react/24/outline';
import { Button } from '@restworld/ui-ds-base';
import { useAuth } from '@restworld/feature-authentication';
import { useResponsiveBreakPoints } from '@restworld/utils-common';

interface ISaveResearchButtonProps {
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
export const SaveResearchButton: React.FunctionComponent<ISaveResearchButtonProps> = ({ onClick }) => {
  const { user } = useAuth();
  const { isDesktop } = useResponsiveBreakPoints();
  const { t } = useTranslation('common');
  return (
    <Button
      StartIcon={BellAlertIcon}
      variant="secondary-neutral"
      onClick={onClick}
      className={'max-h-[48px]'}
      testId="save-research-button"
    >
      {!isDesktop && user?.type === 'ambassador' ? '' : t('save')}
    </Button>
  );
};

export default SaveResearchButton;
